var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEurope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 448,
    height: 320,
    viewBox: "0 0 448 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_21170754971626934389",
    "data-name": 21170754971626934000,
    transform: "translate(-32 -96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43886",
    "data-name": "Path 43886",
    d: "M32,96H480V416H32Z",
    fill: "#2a2faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43887",
    "data-name": "Path 43887",
    d: "M256,136l5.389,16.584h17.437l-14.107,10.249,5.388,16.583L256,169.167,241.89,179.416l5.389-16.583-14.107-10.249h17.437Z",
    fill: "#ffe70e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43888",
    "data-name": "Path 43888",
    d: "M256,328l5.389,16.584h17.437l-14.107,10.249,5.388,16.583L256,361.167,241.89,371.416l5.389-16.583-14.107-10.249h17.437Z",
    fill: "#ffe70e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43889",
    "data-name": "Path 43889",
    d: "M192,296l5.389,16.584h17.437l-14.107,10.249,5.388,16.583L192,329.167,177.89,339.416l5.389-16.583-14.107-10.249h17.437Z",
    fill: "#ffe70e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43890",
    "data-name": "Path 43890",
    d: "M192,168l5.389,16.584h17.437l-14.107,10.249,5.388,16.583L192,201.167,177.89,211.416l5.389-16.583-14.107-10.249h17.437Z",
    fill: "#ffe70e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43891",
    "data-name": "Path 43891",
    d: "M320,296l5.389,16.584h17.437l-14.107,10.249,5.388,16.583L320,329.167,305.89,339.416l5.389-16.583-14.107-10.249h17.437Z",
    fill: "#ffe70e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43892",
    "data-name": "Path 43892",
    d: "M320,168l5.389,16.584h17.437l-14.107,10.249,5.388,16.583L320,201.167,305.89,211.416l5.389-16.583-14.107-10.249h17.437Z",
    fill: "#ffe70e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43893",
    "data-name": "Path 43893",
    d: "M152,232l5.389,16.584h17.437l-14.107,10.249,5.388,16.583L152,265.167,137.89,275.416l5.389-16.583-14.107-10.249h17.437Z",
    fill: "#ffe70e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43894",
    "data-name": "Path 43894",
    d: "M360,232l5.389,16.584h17.437l-14.107,10.249,5.388,16.583L360,265.167,345.89,275.416l5.389-16.583-14.107-10.249h17.437Z",
    fill: "#ffe70e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurope);
export default __webpack_public_path__ + "static/media/europe.ef01a371034e155076a7eee6a3c74d10.svg";
export { ForwardRef as ReactComponent };